<template>
    <vue-draggable-resizable :id="note.id"
        class="ql-note" :class="{'note-editing': editing, 'disable-text': disableText}"
        :x="notePosLeft" :y="notePosTop" :w="note.width" :h="note.height"
        :minw="40" :minh="40"
        :handles="['br']"
        :active="editing"
        :parent="true"
        :draggable="!locked" :resizable="!locked"
        @dragging="onDrag"
        @dragstop="onDragStop" @resizestop="onResize"
        drag-handle=".drag"

        @activated="onActivate" @deactivated="onDeactivate" >
        <md-dialog :md-open-from="`#${note.id}`" :md-close-to="`#${note.id}`" ref="text-edit-dialog">
            <md-dialog-title>Edit Note</md-dialog-title>
            <md-dialog-content>        
                <textarea class="note-input" v-model="note.text" placeholder="Enter Text"></textarea>
                <div class="layer-picker-container">
                    <layer-picker :currentLayer="layerByID(note.layer)" :layers="validLayers" :editable="!locked" @selectLayer="selectLayer" :locked="locked"/>
                    <span>Select Note Layer</span>
                </div>
            </md-dialog-content>
            <md-dialog-actions>
                <md-button class="md-primary" @click="close">Done</md-button>
            </md-dialog-actions>
        </md-dialog>
        <span @click="edit" class="note-text" ref="note-text">
            {{noteText}}
        </span>
        <div class="button-container" v-if="editing && !locked">
            <span class="edit-button drag md-mini">
                <md-icon>zoom_out_map</md-icon>
                <md-tooltip>Move</md-tooltip>
            </span>
            <span class="edit-button md-mini" @click="open">
                <md-icon>edit</md-icon>
                <md-tooltip>Edit</md-tooltip>
            </span>
            <span class="edit-button md-mini" @click="remove">
                <md-icon>clear</md-icon>
                <md-tooltip>Delete</md-tooltip>
            </span>
        </div>
    </vue-draggable-resizable>

<!--             @dragging="onDrag"
        @dragstop="onDrag" -->
</template>

<script>

import vueDragResize from 'vue-draggable-resizable';
import { mapGetters } from 'vuex';

import ProjectCuesLayerPicker from '@/components/project/cues/layer-picker';
/**
 * Component For...
 */
const ProjectNotesNote = {
    name: 'ProjectNotesNote',
    props: ['note', 'locked', 'pageWidth', 'pageHeight'],
    data: function() {
        return {
            editing: false,
            disableText: false,
            dragging: false
        };
    },
    components: {
        'vue-draggable-resizable': vueDragResize,
        'layer-picker': ProjectCuesLayerPicker
    },
    computed: {
        ...mapGetters([
            'layerByID',
            'validLayers'
        ]),
        noteText() {
            return this.note.text || 'Click to edit';
        },
        notePosLeft() {
            if (!this.dragging && this.note.x <= 1) {
                return this.note.x * this.pageWidth;
            }
            return this.note.x;
        },
        notePosTop() {
            if (!this.dragging && this.note.y <= 1) {
                return this.note.y * this.pageHeight;
            }
            return this.note.y;
        }
    },
    methods: {
        edit() {
            this.disableText = true;
            this.editing = true;
            this.$emit('activated');
        },
        open() {
            this.$refs['text-edit-dialog'].open();
        },
        close() {
            this.$emit('updateNote', this.note);
            this.$refs['text-edit-dialog'].close();
        },
        remove() {
            this.$emit('deactivated');
            this.$store.dispatch('removeUserNote', {
                note: this.note
            });
        },
        onDrag(x, y) {
            this.note.x = x;
            this.note.y = y;
            this.dragging = true;
        },
        onDragStop(x, y) {
            const note = {
                ...this.note,
                x,
                y
            };
            this.dragging = false;
            this.$emit('updateNote', note);
        },
        onResize(x, y, width, height) {
            const note = {
                ...this.note,
                x,
                y,
                width,
                height
            };
            this.$emit('updateNote', note);
        },
        onActivate() {
            
        },
        onDeactivate() {
            this.$emit('deactivated');
            this.editing = false;
            this.disableText = false;
        },
        selectLayer(layerID) {
            const note = {
                ...this.note,
                layer: layerID
            };
            this.$emit('updateNote', note);
        }
    }
};

export default ProjectNotesNote;
</script>

<style lang="scss">

.ql-note {
    pointer-events: fill;
    padding-left: 5px;
    z-index: 100;
}

.note-editing {
    border: 1px solid black;
    background-color: #FFF;

}

.button-container {
    position: absolute;
    top: 0px;
    left: -20px;
    cursor: pointer;
    width: 20px;
}

.edit-button {
    display: inline-block;
}

.edit-button .md-icon{
    font-size: 16px;
}

.note-text {
    // font-family:Arial,sans-serif;
    font-size:15px;
    // line-height: 12px;
}

.note-input {
    display: block;
    min-width: 200px;
    width: 90%;
    min-height: 100px;
}

.disable-text {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.layer-picker-container {
    position: relative;
    height: 50px;
    padding-left: 55px;
    padding-top: 16px;
    margin-top: 10px;
}

</style>


// WEBPACK FOOTER //
// note.vue?cc14a994